import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { url } from "../base/Variables";
import { LazyAxios, catchError, handleRequest } from "../base";

const initialState = {
    shop_loading: false,
    shop_error: null,
    shop_success: null,
    shop_error_type: null,
    all_shop: null,
    shop_action: null,
    shop_contact: null
}

const getAllShop = createAsyncThunk('getAllShop', async (_, { rejectWithValue }) => {
    try {
        const axios = await LazyAxios()
        const request = await axios.get(`${url}/api/v1/shop/all/`)
        return handleRequest(request, rejectWithValue)
    }
    catch (error) {
        return rejectWithValue(catchError(error))
    }
})

const shopSlice = createSlice({
    name: 'shopSlice',
    initialState: initialState,
    reducers: {
        shopSliceDefault(state, action) {
            state.shop_loading = false
            state.shop_error = null
            state.shop_success = null
            state.shop_error_type = null
            state.shop_action = null
        },
        setShopContact(state, action) {
            state.shop_contact = [...action.payload]
        },
        setShopDefault(state, action) {
            state.shop_error = null
            state.shop_error_type = null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllShop.pending, (state) => {
                state.shop_loading = true
                state.shop_error = null
                state.shop_error_type = null
                state.shop_success = null
            })
            .addCase(getAllShop.fulfilled, (state, action) => {
                state.shop_loading = false
                state.all_shop = action.payload.data
            })
            .addCase(getAllShop.rejected, (state, action) => {
                state.shop_loading = false
                state.shop_error = action.payload.error_message
                state.shop_error_type = action.payload.type
            })
    }
})

export default shopSlice;
export { getAllShop }
export const { shopSliceDefault, setShopContact, setShopDefault } = shopSlice.actions
